import * as Yup from "yup";

import {
  Button,
  Card,
  CardContent,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Form, Formik } from "formik";

import CustomAlert from "../../../components/CustomAlert";
import CustomDialog from "../../../components/CustomDialog";
import { updateApplicationReferral } from "../../../../services/applicationReferral";
import useLocale from "../../../../hooks/useLocale";
import { useMutation } from "react-query";
import { useState } from "react";

const useStyles = makeStyles({
  dialog: {
    height: 600,
    width: 600,
  },
  uploadButton: {
    marginBottom: 10,
    marginTop: 20,
  },
});

const UpdateDialog = ({
  open,
  close,
  refetch,
  appl_id,
  flowId,
  selectedItem,
}) => {
  const classes = useStyles();
  const [error, setError] = useState("");
  const { t } = useLocale();
  // Mutation for creating data
  const { mutate } = useMutation(updateApplicationReferral, {
    onSuccess: (data) => {
      refetch();
      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  const validationSchema = Yup.object().shape({
    file: Yup.object().shape({
      referral_doc: Yup.string().required("File is required"),
    }),
  });

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleUpdateItem = (values) => {
    mutate({
      ...values.file,
      id: selectedItem.id,
    });
  };

  return (
    <CustomDialog
      open={open}
      maxWidth="lg"
      onClose={() => {
        close();
        setError("");
      }}
    >
      <DialogTitle id="form-dialog-title">{t("Upload referral")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(
            "Pick what kind of referral file you want to Upload, press on Upload button to pick a file from the computer"
          )}
        </DialogContentText>
      </DialogContent>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />
      <Formik
        initialValues={{
          file: selectedItem,
          fileToView: null,
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleUpdateItem(values);
          setSubmitting(false);
        }}
      >
        {({
          submitForm,
          isSubmitting,
          setFieldValue,
          resetForm,
          touched,
          errors,
          values,
          files,
        }) => (
          <Form>
            <DialogContent className={classes.dialog}>
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="h6">{selectedItem?.referral}</Typography>
                  <input
                    accept="application/pdf,image/jpeg"
                    style={{ display: "none" }}
                    id="raised-button-file"
                    hidden
                    type="file"
                    onChange={async (event) => {
                      event.persist();
                      setFieldValue("file", {
                        appl_id: appl_id,
                        referral_kind_id: selectedItem.referral_kind_id,
                        referral_doc: await toBase64(event.target.files[0]),
                        file_name: event.target.files[0].name,
                        content_type: event.target.files[0].type,
                      });
                    }}
                  />

                  <label htmlFor="raised-button-file">
                    <Button
                      className={classes.uploadButton}
                      variant="contained"
                      color="primary"
                      component="span"
                    >
                      {t("Upload referral")}
                    </Button>
                  </label>

                  <Typography variant="body1">
                    {values.file.file_name}
                  </Typography>
                </CardContent>
              </Card>
            </DialogContent>
            <DialogActions>
              <Button onClick={submitForm} color="primary">
                {t("Add")}
              </Button>
              <Button
                onClick={() => {
                  close();
                  setError("");
                }}
                color="primary"
              >
                {t("Cancel")}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </CustomDialog>
  );
};

export default UpdateDialog;
